var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"alt":_vm.title,"src":_vm.imgSrc}})}
var staticRenderFns = []

export { render, staticRenderFns }